const overscrollBehavior = {
    name: "overscroll-behavior",
    path: "/overscroll-behavior",
    title: "overscroll-behavior",
    description: "Utilities for controlling how the browser behaves when reaching the boundary of a scrolling area.",
    value: {
        "overscroll-behavior": {
          "overscroll-auto": "auto",
          "overscroll-contain": "contain",
          "overscroll-none": "none",
        },
        "overscroll-behavior-x": {
          "overscroll-x-auto": "auto",
          "overscroll-x-contain": "contain",
          "overscroll-x-none": "none",
        },
        "overscroll-behavior-y": {
          "overscroll-y-auto": "auto",
          "overscroll-y-contain": "contain",
          "overscroll-y-none": "none",
        }
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="overscroll-contain ...">Well, let me tell you something, ...</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="overscroll-none ...">Well, let me tell you something, ...</div>
                `
            },
        }
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">overscroll-contain</code>
                  utility to prevent scrolling in the target area from triggering scrolling in the parent element, but preserve "bounce" effects when scrolling past the end of the container in operating systems that support it:
            </p>
            <div class="border border-color-gray-200 rounded-lg h-48 space-y-4 overflow-auto overscroll-contain p-8 text-color-gray-600 dark:bg-color-gray-800 dark:text-color-gray-400 dark:border-color-gray-700">
                <p>
                    Well, let me tell you something, funny boy. Y'know that little stamp, the one that says "New York Public Library"? Well that may not mean anything to you, but that means a lot to me. One whole hell of a lot.</p>
                <p>
                    Sure, go ahead, laugh if you want to. I've seen your type before: Flashy, making the scene, flaunting convention. Yeah, I know what you're thinking. What's this guy making such a big stink about old library books? Well, let me give you a hint, junior.</p>
                <p>
                    Maybe we can live without libraries, people like you and me. Maybe. Sure, we're too old to change the world, but what about that kid, sitting down, opening a book, right now, in a branch at the local library and finding drawings of pee-pees and wee-wees
                    on the Cat in the Hat and the Five Chinese Brothers? Doesn't HE deserve better?</p>
            </div>
            
            `
        },
         {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">overscroll-none</code>
                 utility to prevent scrolling in the target area from triggering scrolling in the parent element, and also prevent "bounce" effects when scrolling past the end of the container:
            </p>
            <div class="border border-color-gray-200 rounded-lg h-48 space-y-4 overflow-auto overscroll-none p-8 text-color-gray-600 dark:bg-color-gray-800 dark:text-color-gray-400 dark:border-color-gray-700">
                <p>
                    Well, let me tell you something, funny boy. Y'know that little stamp, the one that says "New York Public Library"? Well that may not mean anything to you, but that means a lot to me. One whole hell of a lot.</p>
                <p>
                    Sure, go ahead, laugh if you want to. I've seen your type before: Flashy, making the scene, flaunting convention. Yeah, I know what you're thinking. What's this guy making such a big stink about old library books? Well, let me give you a hint, junior.</p>
                <p>
                    Maybe we can live without libraries, people like you and me. Maybe. Sure, we're too old to change the world, but what about that kid, sitting down, opening a book, right now, in a branch at the local library and finding drawings of pee-pees and wee-wees
                    on the Cat in the Hat and the Five Chinese Brothers? Doesn't HE deserve better?</p>
            </div>
            
            `
        }
    ]
};

export default overscrollBehavior;

<div className="sr-only">
 <div class="h-48 space-y-4 overflow-auto overscroll-contain overscroll-none p-8 text-color-gray-600 dark:bg-color-gray-800 dark:text-color-gray-400"></div>
</div>